{
  "adhoc": {
    "archiveQuestion": "Archive Question",
    "confirmArchiveMessage": "Are you sure you want to archive this question? It will be moved to the archives.",
    "confirmDeletePermanentlyMessage": "Are you sure you want to permanently delete this question? This action cannot be undone.",
    "confirmRestoreMessage": "Are you sure you want to restore this question? It will be visible again.",
    "deleteQuestionPermanently": "Delete Question Permanently",
    "noResultsYet": "No results yet",
    "restoreQuestion": "Restore Question",
    "runSimulationToSeeResults": "Run the question to see results here",
    "triggeringQuestion": "Starting..."
  },
  "audienceBuilder": {
    "addBehaviorGroup": "Add behavior group",
    "addMarket": "Add Segment",
    "addingMarket": "Adding segment...",
    "ageRange": "Age range",
    "allGenders": "All genders",
    "audienceSummary": "Audience Summary",
    "behaviorGroup": "Behavior Group {{index}}",
    "behaviors": "Behaviors",
    "completedSummary": {
      "one": "Your study reached {{respondents}} respondents across {{count}} segment.",
      "other": "Your study reached {{respondents}} respondents across {{count}} segments.",
      "zero": "Your study reached {{respondents}} respondents."
    },
    "continue": "Continue",
    "countries": "Countries",
    "countryCount": {
      "one": "{{count}} country",
      "other": "{{count}} countries",
      "zero": "Worldwide"
    },
    "demographics": "Filter demographics",
    "demographicsReadonly": "Demographics",
    "equalizeWeights": "Equalize",
    "extraFilters": {
      "one": "+{{count}} filter",
      "other": "+{{count}} filters",
      "zero": "No filters"
    },
    "gender": "Gender",
    "genderAgeSummary": "{{gender}}, {{ageMin}}-{{ageMax}}",
    "inProgressSummary": "Your study is running. Results will be available shortly.",
    "launchBlockedByErrors": {
      "one": "{{count}} error needs fixing",
      "other": "{{count}} errors need fixing"
    },
    "launchEstimate": {
      "one": "Results in about {{count}} minute.",
      "other": "Results in about {{count}} minutes.",
      "zero": "Results in under a minute."
    },
    "launchStudy": "Launch Study",
    "launchSummary": {
      "one": "Your study will reach {{respondents}} respondents across {{count}} segment.",
      "other": "Your study will reach {{respondents}} respondents across {{count}} segments.",
      "zero": "Your study will reach {{respondents}} respondents."
    },
    "mapViewWorld": "World",
    "mapWebOnly": "Map available on web only",
    "marketName": "Segment {{number}}",
    "presetAfrica": "Africa",
    "presetAsia": "Asia",
    "presetEurope": "Europe",
    "presetMiddleEast": "Middle East",
    "presetNorthAmerica": "North America",
    "presetOceania": "Oceania",
    "presetSouthAmerica": "South America",
    "questionSubtitle": "Write your question and configure the answer options below.",
    "questionTitle": "What do you want to ask?",
    "readyToLaunch": "Ready to launch",
    "respondentsShort": "{{count}} resp.",
    "resultsSubtitle": "Review the results of your audience simulation",
    "resultsTitle": "Results",
    "sampleSize": "Sample size for this study",
    "savedMarket": "Saved segment",
    "savedMarkets": "Saved segments",
    "searchCountries": "Search countries",
    "searchStates": "Search states",
    "seeProgress": "See Progress",
    "seeResults": "See Results",
    "selectCountries": "Select countries",
    "selectSegmentHint": "Select a segment to continue",
    "selectedDemographics": {
      "one": "{{label}}: {{count}} filter",
      "other": "{{label}}: {{count}} filters",
      "zero": "No {{label}}"
    },
    "stepAudience": "Audience",
    "stepQuestion": "Question",
    "stepResults": "Results",
    "studyComplete": "Study complete",
    "studyInProgress": "Study in progress",
    "studyQuestionsSubtitle": "Build the questions and sections of your survey.",
    "studyQuestionsTitle": "Design your survey",
    "subtitle": "Pick a saved segment, describe your audience, or customize filters below.",
    "title": "Who do you want to reach?"
  },
  "auth": {
    "subtitle": "Continuous market research for brands that move fast.",
    "tagline": "Simulate every audience, ",
    "taglineItalic": "get insights in minutes"
  },
  "billing": {
    "activity": "Activity",
    "columnAmount": "Amount",
    "columnCredits": "Credits",
    "columnDate": "Date",
    "columnInvoice": "Invoice",
    "columnStatus": "Status",
    "columnType": "Type",
    "creditBalance": "Credit Balance",
    "currentPlan": "Current Plan",
    "estimatedCost": {
      "one": "Estimated cost: {{count}} credit",
      "other": "Estimated cost: {{count}} credits"
    },
    "intervalDay": "Daily",
    "intervalMonth": "Monthly",
    "intervalWeek": "Weekly",
    "intervalYear": "Yearly",
    "invoices": "Invoices",
    "manage": "Manage",
    "next": "Next",
    "noInvoices": "No invoices found.",
    "noPlan": "No active plan",
    "noTransactions": "No activity found.",
    "pageOf": "Page {{current}} of {{total}}",
    "previous": "Previous",
    "quickInsights": "Quick insights",
    "statusPending": "Pending",
    "statusProcessed": "Processed",
    "study": "Study",
    "subscribe": "Subscribe",
    "subtitle": "Manage your credits, subscription, and invoices.",
    "title": "Billing & Invoices",
    "type": {
      "adjustment": "Adjustment",
      "hold": "Credit hold",
      "refund": "Refund",
      "subscription": "Subscription renewal",
      "topup": "Credit top-up",
      "usage": "Simulation usage"
    },
    "unlimited": "Unlimited"
  },
  "clerk": {
    "newDeviceNotice": "You're signing in from a new device, so we've emailed you a verification code. It can take up to a minute to arrive. Remember to check your spam folder.",
    "noAccount": "Don't have an account?",
    "requestFreeTrial": "Request free trial",
    "resendCode": "Still waiting? Resend the code",
    "waitlistAlreadyAccess": "Already have access?",
    "waitlistSignIn": "Sign in",
    "waitlistSubtitle": "Enter your email address to request a 7-day free trial",
    "waitlistSuccessMessage": "You will be redirected soon...",
    "waitlistSuccessSubtitle": "We'll be in touch with you shortly",
    "waitlistSuccessTitle": "Thanks for requesting a free trial!",
    "waitlistTitle": "Join with free trial"
  },
  "dashboard": {
    "activeStudies": "Studies",
    "activeStudiesCount": {
      "one": "{{count}} active",
      "other": "{{count}} active",
      "zero": "No active"
    },
    "activeStudiesDescription": "For advanced, in-depth research that needs more control",
    "allUseCases": "All tests",
    "customTest": "Custom Test",
    "errorLoadingStudies": "Could not load studies",
    "getStarted": "Get Started",
    "linearScaleDescription": "Custom endpoint numeric scales",
    "managePanels": "Saved Segments",
    "managePanelsDescription": "Configure your segments demographics and settings",
    "multiSelectMatrixDescription": "Multiple selections per row in a grid",
    "multipleChoiceDescription": "Select all options that apply",
    "noLaunchPermission": "You don't have the necessary permissions to launch this simulation.",
    "noRecentStudies": "No recent studies",
    "npsDescription": "Likelihood to recommend, on a 0-10 scale",
    "openEndedDescription": "Collect free-text responses",
    "pastQuestions": "Past Questions",
    "pricingDescription": "Ask respondents to type a price they would pay for a product or service.",
    "questionCount": {
      "one": "{{count}} question",
      "other": "{{count}} questions",
      "zero": "No questions"
    },
    "quickActions": "Quick Actions",
    "quickInsights": "Quick Tests",
    "quickInsightsDescription": "Run quick tests on ads, packs, claims and more using our ready-made templates.",
    "quickTests": "Quick tests",
    "rankingDescription": "Rank items by any criteria",
    "ratingScaleDescription": "Rate items on a numeric scale",
    "recentStudies": "Recent Studies",
    "seeMore": "See more",
    "singleChoiceDescription": "Pick one answer from a list",
    "singleSelectMatrixDescription": "One selection per row in a grid",
    "useCases": {
      "adCreative": "Ad Creative Testing",
      "adCreativeDescription": "Show each consumer your ads one at a time, measuring what they take away, how much they like them, and the interest they spark.",
      "awareness": "Brand Awareness",
      "awarenessDescription": "Measure how many consumers think of each brand in your category on their own, and how many recognize them on a list.",
      "claimTest": "Claim Testing",
      "claimTestDescription": "Show each consumer your claims one at a time, measuring what they understand, how believable each feels, and how motivating it is.",
      "maxDiff": "MaxDiff",
      "maxDiffDescription": "Show consumers small groups of items and ask them to pick best and worst across rounds, revealing what really matters.",
      "monadic": "Concept Testing",
      "monadicDescription": "Show each consumer one product concept at a time, so each idea is rated on its own and not next to others.",
      "nps": "NPS",
      "npsDescription": "Ask consumers how likely they are to recommend your product on a 0 to 10 scale, plus the reason behind their score.",
      "packaging": "Packaging Testing",
      "packagingDescription": "Show each consumer your packs one at a time, measuring what product they see, how appealing each feels, and its shelf standout.",
      "preferenceTest": "Preference Test",
      "preferenceTestDescription": "Show consumers two or more ads, packs, or claims side by side, and find out which one they prefer, and why.",
      "priceElasticity": "Price Elasticity",
      "priceElasticityDescription": "Identify the price range where consumers see real value, what feels too cheap to trust, too expensive, or just right.",
      "turf": "TURF",
      "turfDescription": "Find the smallest portfolio, for a shelf, a menu, or a lineup, that satisfies the widest range of consumer tastes."
    },
    "viewAll": "View all",
    "welcome": "Welcome, {{name}}",
    "welcomeDescription": "What would you like to test today?",
    "yourFavorites": "Your favorites"
  },
  "dashboardNavigator": {
    "accountLanguageDefault": "Account Language (Default)",
    "accountProfile": "Profile",
    "accountSecurity": "Security",
    "accountSecurityDescription": "Manage your password, devices, and active sessions.",
    "accountSettings": "Account Settings",
    "activeSessions": "Active Sessions",
    "addEmailPlaceholder": "Add new email address",
    "age": "{{age}} years old",
    "ageRange": "Age must be between {{lowerBound}} and {{upperBound}}",
    "allGroups": "All Groups",
    "archives": "Archives",
    "areaType": "Area Type",
    "avgRank": "Avg. rank",
    "behaviorLabel": "Behavior",
    "behaviorPlaceholder": "Prefers online shopping",
    "behaviors": {
      "one": "1 behavior",
      "other": "{{count}} behaviors",
      "zero": "No behaviors"
    },
    "browserDefault": "Browser (Default)",
    "cannotUnlinkLastAccount": "You need at least one sign-in method. Set a password first to unlink this account.",
    "changePassword": "Change Password",
    "chartTitleDistribution": {
      "one": "Distribution (1 response)",
      "other": "Distribution ({{count}} responses)",
      "zero": "Distribution (No respondents)"
    },
    "chartTitleHeatmap": {
      "one": "Topic Heatmap (1 response)",
      "other": "Topic Heatmap ({{count}} responses)",
      "zero": "Topic Heatmap (No respondents)"
    },
    "chartTitleKeyThemes": {
      "one": "Key Themes (1 response)",
      "other": "Key Themes ({{count}} responses)",
      "zero": "Key Themes (No respondents)"
    },
    "chartTitleNps": {
      "one": "Net Promoter Score (1 respondent)",
      "other": "Net Promoter Score ({{count}} respondents)",
      "zero": "Net Promoter Score (No respondents)"
    },
    "chartTitleNpsBreakdown": {
      "one": "NPS Breakdown (1 respondent)",
      "other": "NPS Breakdown ({{count}} respondents)",
      "zero": "NPS Breakdown (No respondents)"
    },
    "chartTitlePriceDistribution": {
      "one": "Price Distribution (1 respondent)",
      "other": "Price Distribution ({{count}} respondents)",
      "zero": "Price Distribution (No respondents)"
    },
    "chartTitleRatings": {
      "one": "Average Rating (1 respondent)",
      "other": "Average Rating ({{count}} respondents)",
      "zero": "Average Rating (No respondents)"
    },
    "chartTitleRatingsBreakdown": {
      "one": "Ratings Breakdown (1 respondent)",
      "other": "Ratings Breakdown ({{count}} respondents)",
      "zero": "Ratings Breakdown (No respondents)"
    },
    "chartTitleResponseDistribution": {
      "one": "Choice Distribution (1 respondent)",
      "other": "Choice Distribution ({{count}} respondents)",
      "zero": "Choice Distribution (No respondents)"
    },
    "chartTitleResponseMatrix": {
      "one": "Answers by Category (1 respondent)",
      "other": "Answers by Category ({{count}} respondents)",
      "zero": "Answers by Category (No respondents)"
    },
    "chartTitleResponseRanking": {
      "one": "Ranking Breakdown (1 respondent)",
      "other": "Ranking Breakdown ({{count}} respondents)",
      "zero": "Ranking Breakdown (No respondents)"
    },
    "chartTitleScoreDistribution": {
      "one": "Score Breakdown (1 respondent)",
      "other": "Score Breakdown ({{count}} respondents)",
      "zero": "Score Breakdown (No respondents)"
    },
    "chartTitleTopResponses": {
      "one": "Top Responses (1 response)",
      "other": "Top Responses ({{count}} responses)",
      "zero": "Top Responses (No respondents)"
    },
    "chartTooltipHeatmap": "{{line}}: {{option}}",
    "children": {
      "one": "1 child",
      "other": "{{count}} children",
      "zero": "No children"
    },
    "comingSoon": "Coming Soon",
    "comingSoonDescription": "We're working on integrating with these platforms to help you run simulations on your own data. Stay tuned for updates!",
    "confirmDeleteGroup": "Delete Group",
    "confirmDeleteGroupMessage": "Are you sure you want to delete this group? This action cannot be undone.",
    "confirmPassword": "Confirm Password",
    "connectedAccounts": "Connected Accounts",
    "conversation": "Conversation",
    "count": "Count",
    "current": "Current",
    "currentPassword": "Current Password",
    "dataSources": "Data Sources",
    "dataSourcesExplanation": "Connect your data sources to run simulations on your own personas.",
    "deleteEmail": "Delete Email",
    "deleteEmailConfirm": "Are you sure you want to delete {{email}}?",
    "demographics": "Demographics",
    "devices": {
      "one": "1 device",
      "other": "{{count}} devices",
      "zero": "No devices"
    },
    "educationLabel": "Education",
    "emailAddresses": "Email Addresses",
    "employmentStatus": "Employment",
    "enterFirstName": "Enter your first name",
    "enterLastName": "Enter your last name",
    "errorLoadingConversation": "Failed to load conversation",
    "errorLoadingDemographics": "Failed to load demographics",
    "ethnicity": "Ethnicity",
    "firstName": "First Name",
    "home": "Home",
    "householdLabel": "Household Size",
    "income": "Income",
    "keyInsights": "Key Insights",
    "languageSettings": "Language Settings",
    "lastName": "Last Name",
    "linearScaleQuestionTitle": "Linear Scale",
    "location": "Location",
    "locationUnknown": "Location unknown",
    "logout": "Logout",
    "logoutConfirm": "Are you sure you want to sign out of your account?",
    "maritalStatus": "Marital Status",
    "maxSmallerThanMin": "Max must be greater than min",
    "multiSelectMatrixQuestionTitle": "Multi Select Matrix",
    "multipleChoiceQuestionTitle": "Multiple Choice",
    "newPassword": "New Password",
    "noActiveSessions": "No active sessions",
    "noConnectedAccounts": "No connected accounts",
    "noData": "No data available",
    "noPasswordSet": "No password set",
    "npsDetractors": "Detractors",
    "npsPassives": "Passives",
    "npsPromoters": "Promoters",
    "npsQuestionTitle": "NPS",
    "npsScale": "−100 to 100",
    "occupation": "Occupation",
    "openEndedQuestionTitle": "Open Ended",
    "organization": "Organization",
    "organizationAdmin": "Admin",
    "organizationDescription": "View members, manage roles, and see organization details.",
    "organizationDomains": "Verified Domains",
    "organizationFullName": "Full Name",
    "organizationMember": "Member",
    "organizationMembers": "Members",
    "organizationNoDomains": "No verified domains",
    "organizationNoMembers": "No members found",
    "organizationOwner": "Owner",
    "organizationRole": "Role",
    "organizationYou": "You",
    "panels": "Segments",
    "password": "Password",
    "passwordEnabled": "Password enabled",
    "passwordProtected": "Your account is protected with a password",
    "passwordTooShort": "Password must be at least 8 characters",
    "passwordUpdateFailed": "Failed to update password. Please check your current password.",
    "passwordsDoNotMatch": "Passwords do not match",
    "personalInformation": "Personal Information",
    "personality": "Personality",
    "pricingQuestionTitle": "Pricing Question",
    "primary": "Primary",
    "questions": "Questions",
    "rankingQuestionTitle": "Ranking",
    "ratingScaleQuestionTitle": "Rating",
    "regionTypeRural": "Rural",
    "regionTypeSuburban": "Suburban",
    "regionTypeUrban": "Urban",
    "respondents": {
      "one": "1 respondent",
      "other": "{{count}} respondents",
      "zero": "No respondents"
    },
    "results": "Results",
    "revoke": "Revoke",
    "revokeSession": "Revoke Session",
    "revokeSessionConfirm": "This will sign out this device. The user will need to sign in again.",
    "revoking": "Revoking...",
    "seeAllCount": {
      "one": "See all (1 verbatim)",
      "other": "See all ({{count}} verbatims)",
      "zero": "See all"
    },
    "setPassword": "Set Password",
    "setPasswordPrompt": "Add a password to secure your account",
    "settings": "Settings",
    "settingsDescription": "Manage your language preferences and security settings.",
    "signOut": "Sign Out",
    "signOutDescription": "Sign out of your account on this device.",
    "singleChoiceQuestionTitle": "Single Choice",
    "singleSelectMatrixQuestionTitle": "Single Select Matrix",
    "studies": "Studies",
    "studyLanguage": "Language of Studies",
    "studyLanguageDescription": "Set the default language for your studies and surveys.",
    "traits": "Traits",
    "unknownDevice": "Unknown device",
    "unlink": "Unlink",
    "unlinkAccount": "Unlink Account",
    "unlinkAccountConfirm": "Are you sure you want to unlink your {{provider}} account? You will no longer be able to sign in with this account.",
    "unlinking": "Unlinking...",
    "values": "Values",
    "verificationCode": "Verification code",
    "verifyEmail": "Enter the verification code sent to {{email}}",
    "websiteLanguage": "Language of Website",
    "websiteLanguageDescription": "Set the display language for the website interface.",
    "weight": "Weight",
    "whatConsumersSaid": "What consumers said"
  },
  "dataSources": {
    "aws": "AWS",
    "awsDescription": "Amazon Web Services",
    "codence": "Codence",
    "codenceDescription": "Customer Research Platform",
    "dovetail": "Dovetail",
    "dovetailDescription": "AI Customer Insights Hub",
    "enjoyHQ": "EnjoyHQ",
    "enjoyHQDescription": "User Research Repository",
    "googleAds": "Google Ads",
    "googleAdsDescription": "Google Advertising Platform",
    "googleCloud": "Google Cloud",
    "googleCloudDescription": "Google Cloud Platform",
    "hubspot": "Hubspot",
    "hubspotDescription": "Marketing & Sales Platform",
    "maze": "Maze",
    "mazeDescription": "Product Discovery Platform",
    "metaAds": "Meta Ads",
    "metaAdsDescription": "Facebook & Instagram Ads",
    "microsoftAzure": "Microsoft Azure",
    "microsoftAzureDescription": "Microsoft Cloud Platform",
    "oracleCloud": "Oracle Cloud",
    "oracleCloudDescription": "Oracle Cloud Infrastructure",
    "salesforce": "Salesforce",
    "salesforceDescription": "Customer Relationship Management",
    "tiktokAds": "TikTok Ads",
    "tiktokAdsDescription": "TikTok Advertising Platform"
  },
  "demographics": {
    "female": "Female",
    "male": "Male",
    "nonBinary": "Non-binary"
  },
  "folders": {
    "confirmArchive": "Archive Folder",
    "confirmArchiveMessage": "Are you sure you want to archive \"{{name}}\"? All contents inside will also be archived.",
    "confirmDeletePermanentlyMessage": "Are you sure you want to permanently delete this folder and all its contents? This action cannot be undone.",
    "confirmRestoreMessage": "Are you sure you want to restore this folder? All contents inside will also be restored.",
    "currentLocation": "Current location",
    "deleteFolderPermanently": "Delete Folder Permanently",
    "errorLoadingFolders": "Failed to load folders",
    "folderNamePlaceholder": "Folder name...",
    "moveItem": "Move {{name}}",
    "newFolder": "New Folder",
    "noFoldersYet": "No folders yet",
    "rename": "Rename Folder",
    "renameFolder": "Rename",
    "subFolderCount": {
      "one": "{{count}} sub-folder",
      "other": "{{count}} sub-folders"
    }
  },
  "menu": {
    "account": "Account",
    "accountDescription": "Manage your profile, emails, and connected accounts.",
    "archives": "Archives",
    "billing": "Billing & Invoices",
    "logout": "Log out",
    "logoutConfirm": "Are you sure you want to sign out of your account?",
    "managePlan": "Manage plan",
    "openMenu": "Open menu",
    "organization": "Organization",
    "settings": "Settings",
    "subscribe": "Subscribe"
  },
  "misc": {
    "apply": "Apply",
    "archive": "Archive",
    "archived": "Archived",
    "archivedQuestionBanner": "You are viewing an archived question. Restore it to make changes.",
    "archivedStudyBanner": "You are viewing an archived study. Restore it to make changes.",
    "archivesEmptyDescription": "Archived items will appear here.",
    "archiving": "Archiving...",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "completed": "Completed",
    "create": "Create",
    "creating": "Creating...",
    "creatingStudy": "Creating Study...",
    "delete": "Delete",
    "deletePermanently": "Delete permanently",
    "deleting": "Deleting...",
    "draft": "Draft",
    "dropFilesHere": "Drop files here",
    "duplicate": "Duplicate",
    "duplicating": "Duplicating...",
    "edit": "Edit",
    "errorLoadingQuestion": "Failed to load the question",
    "errorLoadingQuestions": "Failed to load questions",
    "errorOccurred": "An error has occurred.",
    "failed": "Failed",
    "failedToGenerateSummary": "Failed to generate summary.",
    "fileSizeExceededImage": "Image exceeds maximum size of {{maxSize}}MB",
    "fileSizeExceededVideo": "Video exceeds maximum size of {{maxSize}}MB",
    "filesRejected": "{{count}} files rejected: {{reason}}",
    "generatingSummary": "Generating summary…",
    "hoursShort": "{{count}}h",
    "imageUpToSize": "Images up to {{maxSize}}MB each",
    "in_progress": "In Progress",
    "invalidImageFormat": "Invalid image format. Please upload JPEG, PNG, GIF, or WebP images.",
    "invalidMediaFormat": "Invalid file format. Please upload valid images or videos.",
    "invalidVideoFormat": "Invalid video format. Please upload MP4 or WebM videos.",
    "loading": "Loading...",
    "maxItemsReached": "Maximum of {{max}} items allowed",
    "mediaUpToSize": "Images up to {{imageMaxSize}}MB each, videos up to {{videoMaxSize}}MB each",
    "minutesShort": "{{count}}m",
    "move": "Move",
    "moving": "Moving...",
    "noArchivedQuestions": "No archived questions",
    "noArchivedQuestionsDescription": "Archived questions will appear here.",
    "noArchivedSegments": "No archived segments",
    "noArchivedSegmentsDescription": "Archived segments will appear here.",
    "noArchivedStudies": "No archived studies",
    "noArchivedStudiesDescription": "Archived studies will appear here.",
    "noQuestionsYet": "No questions yet",
    "noSearchResults": "No results found",
    "noSearchResultsDescription": "Try adjusting your search terms",
    "otherValues": "Other",
    "permissionRequiredMessage": "Sorry, we need camera roll permissions to select media.",
    "readMore": "Read more",
    "ready": "Ready",
    "reset": "Reset",
    "restore": "Restore",
    "restoring": "Restoring...",
    "retrying": "Retrying...",
    "save": "Save",
    "saving": "Saving...",
    "search": "Search...",
    "searchQuestions": "Search questions...",
    "searchStudies": "Search studies...",
    "secondsShort": "{{count}}s",
    "seeLess": "See less",
    "seeMore": "See more",
    "selectedImageAlt": "Selected image {{index}}",
    "showOriginal": "Show original",
    "showTranslation": "Show translation",
    "tapToSelectImages": "Tap to select images",
    "tapToSelectMedia": "Tap to select files",
    "tapToSelectVideos": "Tap to select videos",
    "translatedFrom": "Translated from {{language}}",
    "tryAgain": "Try Again",
    "typeMessage": "Type a message...",
    "unknown": "Unknown",
    "uploadImages": "Upload Images (up to {{max}})",
    "uploadMedia": "Upload Media (up to {{max}})",
    "uploadVideos": "Upload Videos (up to {{max}})",
    "uploadingMedia": {
      "one": "Uploading 1 file... {{percent}}",
      "other": "Uploading {{count}} files... {{percent}}",
      "zero": "No files to upload"
    },
    "videoUpToSize": "Videos up to {{maxSize}}MB each"
  },
  "notFound": {
    "goToHomeScreen": "Go to home screen",
    "notFound": "Can't find what you're looking for"
  },
  "panels": {
    "confirmArchive": "Archive Segment",
    "confirmArchiveMessage": "Are you sure you want to archive this segment?\nGroups using this segment will continue to work but you won't be able to use this segment for newly created groups.",
    "createPanel": "Create Segment",
    "default": "Default",
    "demographics": "Demographics",
    "description": "Description",
    "editPanel": "Edit Segment",
    "errorLoadingPanels": "Failed to load segments",
    "noSegments": "No segments",
    "noSegmentsDescription": "There are no segments available yet.",
    "panelName": "Segment Name",
    "setAsDefault": "Set as default"
  },
  "questions": {
    "addConditionalRule": "Add conditional rule",
    "addOption": "Add option",
    "addProbabilityRule": "Add probability rule",
    "advancedSettings": "Advanced settings",
    "afterThisQuestion": "After this question:",
    "archiveQuestion": "Archive Question",
    "arrow": "→",
    "averagePrice": {
      "one": "Average Price (1 respondent)",
      "other": "Average Price ({{count}} respondents)",
      "zero": "Average Price (No respondents)"
    },
    "averageScore": {
      "one": "Average Score (1 respondent)",
      "other": "Average Score ({{count}} respondents)",
      "zero": "Average Score (No respondents)"
    },
    "carryForward": {
      "exclude": "excluding items selected in Q{{number}}",
      "excludeHint": "Options selected in that question are removed from the ported list.",
      "excludeLabel": "Exclude options selected in (optional)",
      "minRating": "Show only items rated \"{{label}}\" or higher in Q{{number}}",
      "modeManualOptions": "Provide options",
      "modeManualRows": "Provide rows",
      "modeReuse": "Reuse a previous answer",
      "none": "None",
      "portRatedPrefix": "Ports rows rated",
      "portRatedSuffix": "or higher as this question's {{target}}.",
      "portSelected": "Ports the options they selected as this question's {{target}}.",
      "reuseFrom": "Reuse answers from",
      "selected": "Show only items selected in Q{{number}}",
      "targetOptions": "options",
      "targetRows": "rows"
    },
    "categoryAssignment": {
      "addCondition": "Add condition",
      "addTrack": "Add track",
      "eligibilityContains": "Eligibility: Q{{number}} contains \"{{option}}\"",
      "eligibilityDoesNotContain": "Eligibility: Q{{number}} does not contain \"{{option}}\"",
      "eligibilityHint": "By default, anyone can be placed in any track. Add a condition to restrict a track to respondents who gave a specific answer.",
      "eligibilityIs": "Eligibility: Q{{number}} is \"{{option}}\"",
      "eligibilityIsNot": "Eligibility: Q{{number}} is not \"{{option}}\"",
      "eligibleWhen": "Eligible when",
      "explanation": "Respondents are split across tracks. Use eligibility to control who can enter a track, and skip logic to route each track to different questions.",
      "leastFill": "Balanced",
      "leastFillHint": "Fill tracks evenly, always assigning to the least-filled eligible track.",
      "method": "Method: {{method}}",
      "random": "Random",
      "randomHint": "Assign to an eligible track at random.",
      "setDestination": "Set destination",
      "title": "Track Assignment",
      "trackLabel": "Track {{number}}",
      "trackStart": "Track starts at",
      "tracksLabel": "Tracks"
    },
    "conditionalRuleDisplay": "If \"{{sourceQuestion}}\" {{operator}} \"{{option}}\" → {{target}}",
    "conditionalRulesTakePrecedence": "Conditional rules take precedence over probability and default rules",
    "confirmArchiveMessage": "Are you sure you want to archive this question? It will be moved to the archives.",
    "confirmDelete": "Delete Question",
    "confirmDeleteMessage": "Are you sure you want to delete this question? This action cannot be undone.",
    "confirmDeletePermanentlyMessage": "Are you sure you want to permanently delete this question? This action cannot be undone.",
    "confirmDeleteWithRulesMessage": "This question is targeted by {{count}} skip rule(s) from other questions. Deleting it will also remove those rules. This action cannot be undone.",
    "confirmRestoreMessage": "Are you sure you want to restore this question? It will be visible again.",
    "contains": "contains",
    "continueToNext": "Continue to next question",
    "createQuestion": "Create Question",
    "default": "Default",
    "deleteQuestionPermanently": "Delete Question Permanently",
    "doesNotContain": "does not contain",
    "editorComingSoon": "Editor coming soon",
    "endSurvey": "End survey",
    "endSurveyWithProbability": "{{percentage}} → End survey",
    "enterOption": "Enter option...",
    "ifAnswer": "If",
    "ifNotSelected": "if not selected",
    "ifSelected": "if selected",
    "is": "is",
    "isNot": "is not",
    "labelsTitle": "Labels",
    "linearScale": {
      "label": "Label"
    },
    "longFormTextAnswer": "Long-form text answer...",
    "matrix": {
      "addColumn": "Add column",
      "addRow": "Add row",
      "columnPlaceholder": "Column label...",
      "columns": "Columns",
      "optionsRange": "{{from}} - {{to}} of {{total}} options",
      "rowPlaceholder": "Row label...",
      "rows": "Rows",
      "rowsRange": "{{from}} - {{to}} of {{total}} rows"
    },
    "minMediaHint": {
      "one": "Add at least {{count}} image",
      "other": "Add at least {{count}} images"
    },
    "minOptionsHint": {
      "one": "Add at least {{count}} option",
      "other": "Add at least {{count}} options"
    },
    "noLinesProvided": "Add rows",
    "noOptionsProvided": "Add options",
    "noTrackDestinations": "Set a destination for every track",
    "npsExtremelyLikely": "Extremely likely",
    "npsExtremelyUnlikely": "Extremely unlikely",
    "option": "Option {{number}}",
    "optionsLabel": "Options",
    "outOfStars": "out of {{count}} stars",
    "pricingPlaceholder": "Type a price…",
    "probabilityRulesSeparator": " • ",
    "probabilitySumError": "⚠️ Sum of probabilities must be less than or equal to 100% (currently {{sum}})",
    "questionPlaceholder": "What would you like to ask?",
    "ranking": {
      "addItem": "Add item",
      "itemPlaceholder": "Item to rank...",
      "itemsLabel": "Items to rank"
    },
    "removeRule": "Remove rule",
    "restoreQuestion": "Restore Question",
    "rulePrecedence": "Option rules > Conditional rules > Probability rules > Default rule",
    "scaleLabel": "Scale",
    "selectOption": "Select an option",
    "selectScale": "Select scale",
    "skipLogic": "Skip Logic",
    "skipToLabel": "Skip to:",
    "skipToQuestion": "Skip to {{number}}",
    "skipToQuestionWithProbability": "{{percentage}} Skip to {{number}}",
    "stars": {
      "one": "{{count}} star",
      "other": "{{count}} stars",
      "zero": "{{count}} stars"
    },
    "types": {
      "categoryAssignment": "Track Assignment",
      "linearScale": "Linear Scale",
      "multiSelectMatrix": "Multi-Select Matrix",
      "multipleChoice": "Multiple Choice",
      "nps": "NPS",
      "openEnded": "Open Ended",
      "pricing": "Pricing",
      "ranking": "Ranking",
      "ratingScale": "Rating",
      "singleChoice": "Single Choice",
      "singleSelectMatrix": "Single-Select Matrix"
    },
    "untitled": "Untitled question",
    "useImagesAsOptions": "Use images as options",
    "whenAnswer": "When the answer",
    "yourQuestion": "Your question"
  },
  "runs": {
    "applyFilters": {
      "one": "Apply ({{count}} respondent)",
      "other": "Apply ({{count}} respondents)",
      "zero": "Apply (no respondents)"
    },
    "fetchingRespondents": "Fetching respondents...",
    "filters": "Filters"
  },
  "sharing": {
    "addPeople": "Add people by name or email...",
    "directAccess": "People with access",
    "editPermission": "Edit",
    "errorLoading": "Failed to load permissions",
    "external": "External",
    "generalAccess": "General access",
    "inheritedFrom": "Inherited from \"{{name}}\"",
    "manageAccess": "Share \"{{name}}\"",
    "owner": "Owner",
    "restricted": "Restricted",
    "share": "Share",
    "viewPermission": "View",
    "you": "(you)"
  },
  "studies": {
    "addSection": "Add section",
    "allStudies": "All Studies",
    "answersProgress": {
      "one": "{{completed}}/{{count}} answer collected",
      "other": "{{completed}}/{{count}} answers collected"
    },
    "archiveStudy": "Archive Study",
    "cell": "Cell {{number}}",
    "cells": {
      "addCell": "Add cell",
      "addField": "Add variable",
      "cellNumber": "Cell {{number}}",
      "cells": "Cells",
      "fieldNamePlaceholder": "Variable name",
      "noVariables": "Define variables first to add cells.",
      "removeCell": "Remove cell",
      "removeField": "Remove field",
      "required": "Required",
      "type": "Type",
      "typeImage": "Image",
      "typeText": "Text",
      "variables": "Variables",
      "variablesHint": "Reference a variable in your questions like this:"
    },
    "confirmArchiveMessage": "Are you sure you want to archive this study? It will be moved to the archives.",
    "confirmDeletePermanentlyMessage": "Are you sure you want to permanently delete this study? All data will be deleted. This action cannot be undone.",
    "confirmDeleteSection": "Delete Section",
    "confirmDeleteSectionMessage": "Are you sure you want to delete this section? Every question inside it will be deleted as well, and the remaining questions will be renumbered. This action cannot be undone.",
    "confirmRestoreMessage": "Are you sure you want to restore this study? It will be visible again.",
    "copyOf": "Copy of {{name}}",
    "coverPicture": "Cover picture",
    "createFirstStudy": "Create your first Study",
    "createFirstStudyDescription": "Fill in the details to create your first research study",
    "createNewStudy": "Create a new Study",
    "createNewStudyDescription": "Fill in the details to create a new research study",
    "createStudy": "Create Study",
    "deleteStudyPermanently": "Delete Study Permanently",
    "design": {
      "createStudy": "Create study",
      "designStudy": "Design study",
      "designing": "Designing...",
      "leave": "Leave",
      "leaveBody": "You have a study draft under review. Leaving this page will delete it.",
      "leaveTitle": "Leave and delete the draft?",
      "noPanelsFound": "No segments found",
      "placeholder": "e.g. Test three claims for our new oat drink with @Gen Z snackers and compare purchase intent...",
      "regenerate": "Regenerate",
      "subtitle": "Describe what you want to learn and tag the segments to ask. Type @ to mention a segment.",
      "title": "What do you want to learn?"
    },
    "duplicateStudy": "Duplicate Study",
    "duplicateStudyDescription": "Create a copy of this study with all its questions and groups",
    "elementsProgress": {
      "one": "{{completed}}/{{count}} element processed",
      "other": "{{completed}}/{{count}} elements processed"
    },
    "errorGettingResults": "Failed to get results",
    "errorGettingSimulationProgress": "Failed to get simulation progress",
    "errorLoadingChat": "Failed to load chat",
    "errorLoadingStudies": "Failed to load studies",
    "errorLoadingStudy": "Failed to load Study",
    "errorRunningSimulation": "Failed to run simulation",
    "exportExcel": "Export as Excel",
    "exportPDF": "Export as PDF",
    "exportWord": "Export as Docx",
    "exporting": "Exporting...",
    "filterByType": "Filter by type",
    "group": "Group {{index}}",
    "keyTakeaways": "Key Takeaways",
    "noChatMessages": "No messages yet",
    "noDescription": "No description provided",
    "noResultsYet": "No results yet",
    "noResultsYetDescription": "Launch a simulation to see results here.",
    "preparingContent": "Preparing content...",
    "qualitative": "Qualitative Studies",
    "qualitativeDescription": "Rich insights with detailed explanations and summaries",
    "qualitativeShort": "Qualitative",
    "quantitative": "Quantitative Studies",
    "quantitativeDescription": "Fast results focused on numerical data",
    "quantitativeShort": "Quantitative",
    "quickInsightsNudge": "Testing a single question? Try",
    "redirectingToResults": "Redirecting to your results…",
    "respondentsProgress": {
      "one": "{{completed}}/{{count}} respondent",
      "other": "{{completed}}/{{count}} respondents"
    },
    "restoreStudy": "Restore Study",
    "runInQueue": "Your study is in the queue and will start shortly",
    "runWaitingToStart": "Waiting to Start",
    "sectionEditor": {
      "addStimulus": "Add item",
      "cellsPerRespondent": "Cells per respondent",
      "cellsPerRespondentHint": {
        "one": "Each respondent sees 1 cell.",
        "other": "Each respondent sees {{count}} cells."
      },
      "description": "Context for respondents",
      "descriptionPlaceholder": "Describe the product, brand, or scenario respondents will react to.",
      "itemsPerCell": "Items per screen",
      "itemsPerCellHint": {
        "one": "1 stimulus is shown per screen.",
        "other": "{{count}} stimuli are shown together on each screen."
      },
      "products": {
        "addStimulus": "Add product",
        "stimuli": "Products",
        "stimulusPlaceholder": "Product {{index}}",
        "summaryNoStimuli": "Add products",
        "summaryStimuli": {
          "one": "1 product",
          "other": "{{count}} products"
        }
      },
      "requiresMediaHint": "An image is required for each item.",
      "settings": "Configuration",
      "stimuli": "Items",
      "stimulusPlaceholder": "Item {{index}}",
      "summaryCells": {
        "one": "1 cell per respondent",
        "other": "{{count}} cells per respondent"
      },
      "summaryItems": {
        "one": "1 item per cell",
        "other": "{{count}} items per cell"
      },
      "summaryNoStimuli": "Add cells",
      "summaryStimuli": {
        "one": "1 item",
        "other": "{{count}} items"
      },
      "title": "Section title",
      "titlePlaceholder": "Enter section title…",
      "useCase": {
        "ad_creative": {
          "addStimulus": "Add ad",
          "cellsPerRespondent": "Ads per respondent",
          "cellsPerRespondentHint": {
            "one": "Each respondent evaluates 1 ad.",
            "other": "Each respondent evaluates {{count}} ads."
          },
          "requiresMediaHint": "Add an image or video for each ad.",
          "stimuli": "Ads",
          "stimulusPlaceholder": "Ad {{index}}",
          "summaryCells": {
            "one": "1 ad per respondent",
            "other": "{{count}} ads per respondent"
          },
          "summaryNoStimuli": "Add ads",
          "summaryStimuli": {
            "one": "1 ad",
            "other": "{{count}} ads"
          }
        },
        "awareness": {
          "addStimulus": "Add brand",
          "stimuli": "Brands",
          "stimulusPlaceholder": "Brand {{index}}",
          "summaryNoStimuli": "Add brands",
          "summaryStimuli": {
            "one": "1 brand",
            "other": "{{count}} brands"
          }
        },
        "claim_test": {
          "addStimulus": "Add claim",
          "cellsPerRespondent": "Claims per respondent",
          "cellsPerRespondentHint": {
            "one": "Each respondent evaluates 1 claim.",
            "other": "Each respondent evaluates {{count}} claims."
          },
          "stimuli": "Claims",
          "stimulusPlaceholder": "Claim {{index}}",
          "summaryCells": {
            "one": "1 claim per respondent",
            "other": "{{count}} claims per respondent"
          },
          "summaryNoStimuli": "Add claims",
          "summaryStimuli": {
            "one": "1 claim",
            "other": "{{count}} claims"
          }
        },
        "max_diff": {
          "cellsPerRespondent": "Tasks per respondent",
          "cellsPerRespondentHint": {
            "one": "Each respondent does 1 MaxDiff task.",
            "other": "Each respondent does {{count}} MaxDiff tasks."
          },
          "itemsPerCell": "Items per task",
          "itemsPerCellHint": {
            "one": "1 item is shown per MaxDiff task.",
            "other": "{{count}} items are shown in each MaxDiff task."
          },
          "summaryCells": {
            "one": "1 task per respondent",
            "other": "{{count}} tasks per respondent"
          },
          "summaryItems": {
            "one": "1 item per task",
            "other": "{{count}} items per task"
          }
        },
        "monadic": {
          "addStimulus": "Add concept",
          "cellsPerRespondent": "Concepts per respondent",
          "cellsPerRespondentHint": {
            "one": "Each respondent evaluates 1 concept.",
            "other": "Each respondent evaluates {{count}} concepts."
          },
          "stimuli": "Concepts",
          "stimulusPlaceholder": "Concept {{index}}",
          "summaryCells": {
            "one": "1 concept per respondent",
            "other": "{{count}} concepts per respondent"
          },
          "summaryNoStimuli": "Add concepts",
          "summaryStimuli": {
            "one": "1 concept",
            "other": "{{count}} concepts"
          }
        },
        "packaging": {
          "addStimulus": "Add pack",
          "cellsPerRespondent": "Packs per respondent",
          "cellsPerRespondentHint": {
            "one": "Each respondent evaluates 1 pack.",
            "other": "Each respondent evaluates {{count}} packs."
          },
          "requiresMediaHint": "Add a picture for each pack.",
          "stimuli": "Packs",
          "stimulusPlaceholder": "Pack {{index}}",
          "summaryCells": {
            "one": "1 pack per respondent",
            "other": "{{count}} packs per respondent"
          },
          "summaryNoStimuli": "Add packs",
          "summaryStimuli": {
            "one": "1 pack",
            "other": "{{count}} packs"
          }
        },
        "preference_test": {
          "addStimulus": "Add variant",
          "stimuli": "Variants",
          "stimulusPlaceholder": "Variant {{index}}",
          "summaryNoStimuli": "Add variants",
          "summaryStimuli": {
            "one": "1 variant",
            "other": "{{count}} variants"
          }
        },
        "price_elasticity": {
          "cellsPerRespondent": "Products per respondent",
          "cellsPerRespondentHint": {
            "one": "Each respondent prices 1 product.",
            "other": "Each respondent prices {{count}} products."
          },
          "summaryCells": {
            "one": "1 product per respondent",
            "other": "{{count}} products per respondent"
          }
        }
      }
    },
    "shareDescription": "This is a public link to your study. Anyone with this link can view this study in read-only mode.",
    "shareResults": "Share results",
    "shareTitle": "Share results",
    "sharing": "Sharing...",
    "startChattingWithAI": "Start chatting with AI to analyze your study results",
    "studyChat": "Study Chat",
    "studyDescription": "Description",
    "studyDescriptionPlaceholder": "Enter a detailed description of your study...",
    "studyName": "Name",
    "studyNamePlaceholder": "Enter study name...",
    "studyType": "Study Type",
    "summariesProgress": {
      "one": "{{completed}}/{{count}} summary",
      "other": "{{completed}}/{{count}} summaries"
    },
    "summaryLoadingAnalyzing": "Analyzing patterns across respondent segments…",
    "summaryLoadingCompiling": "Compiling findings by demographic and segment…",
    "summaryLoadingDrafting": "Drafting executive summary and recommendations…",
    "summaryLoadingIdentifying": "Identifying key themes and sentiment signals…",
    "timeElapsed": "Time elapsed: {{time}}",
    "timeRemaining": "Estimated time remaining: {{time}}",
    "triggeringSimulation": "Starting...",
    "typeYourMessage": "Type your message...",
    "useCasePicker": {
      "custom": "Custom section",
      "customDescription": "Start from a blank section and add your own questions.",
      "title": "Pick a use case to start from"
    },
    "viewDetailed": "View detailed",
    "viewReport": "View report",
    "waitingForProgress": "Waiting for progress...",
    "workingOnItMessage": "Grab a coffee while we run your study...",
    "workingOnItMessageAlmostReady": "Hang tight, your insights are almost here..."
  },
  "useCasePage": {
    "adCreative": {
      "ctaSubtitle": "Get reactions to your ads in under 10 minutes.",
      "ctaTitle": "Launch an ad creative test",
      "methodology": {
        "description": "Each respondent watches every ad in your set, one at a time, and answers the same five questions about each. Because each ad is rated on its own, scores reflect standalone reactions, the way the ad would actually land in the wild.",
        "metrics": {
          "likingIndex": {
            "description": "A blended score across liking, brand fit and purchase interest, so each ad has one number you can compare.",
            "title": "Liking index"
          },
          "takeaway": {
            "description": "What consumers actually think the ad is saying, in their own words.",
            "title": "Takeaway themes"
          }
        },
        "name": "Sequential monadic"
      },
      "provide": {
        "description": "1 to 5 ad creatives: images, animatics or short clips. A short working title for each makes the report easier to read.",
        "examples": {
          "functional": {
            "description": "15-second product shot focused on the gold foil and a precise cocoa-percentage callout.",
            "name": "Functional close-up"
          },
          "heritage": {
            "description": "60-second cinematic film tracing a single cocoa bean from a Ghanaian farm to a finished bar.",
            "name": "Heritage hero spot"
          },
          "lifestyle": {
            "description": "30-second urban scene with friends sharing the bar at a rooftop dinner party.",
            "name": "Lifestyle moment"
          }
        },
        "title": "Your ads"
      },
      "sampleReport": {
        "ads": {
          "functional": {
            "name": "Functional close-up"
          },
          "heritage": {
            "name": "Heritage hero"
          },
          "lifestyle": {
            "name": "Lifestyle moment"
          }
        },
        "metrics": {
          "brandFit": "Brand fit",
          "interest": "Interest",
          "liking": "Liking",
          "subtitle": "Top-2-box share for each ad on each scale, alongside the takeaway theme.",
          "title": "How each ad performed, by metric"
        },
        "ranking": {
          "subtitle": "Blended score across the three rating questions, on a 0–100 scale.",
          "title": "Liking index by ad"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers, 3 ads tested.",
        "summary": {
          "body": "Heritage hero earns the strongest blended score thanks to a clear story arc and high brand fit. Lifestyle moment lands as fun but generic: high liking, low brand fit. Functional close-up is the easiest to understand but the hardest to feel anything about: comprehension is near-perfect, intent is the lowest of the three.",
          "headline": "Heritage hero leads on liking and intent, while Functional close-up wins on clarity but loses on feeling."
        },
        "winner": {
          "badge": "Top creative",
          "compositeLabel": "Liking index",
          "subtitle": "Highest blended score across liking, brand fit and interest."
        }
      }
    },
    "awareness": {
      "ctaSubtitle": "Get a clean awareness funnel in under 10 minutes.",
      "ctaTitle": "Launch an awareness study",
      "methodology": {
        "description": "Awareness is measured in two stages, in fixed order to avoid priming. First, respondents type the brands that come to mind for the category. Then they're shown your full brand list and tick every brand they've heard of. Spontaneous mentions are matched at analysis time against the same list to compute unaided recall.",
        "metrics": {
          "aided": {
            "description": "Percentage of respondents who recognize a brand when shown your candidate list. The ceiling: passive familiarity.",
            "title": "Aided awareness"
          },
          "unaided": {
            "description": "Percentage of respondents who name a brand spontaneously, with no list shown. The harder bar: active recall.",
            "title": "Unaided awareness"
          }
        },
        "name": "Two-stage awareness funnel"
      },
      "provide": {
        "description": "The brands you want to measure. 3 to 15 brands.",
        "title": "List of brands"
      },
      "sampleReport": {
        "brands": {
          "cadbury": "Cadbury",
          "ferrero": "Ferrero Rocher",
          "ghirardelli": "Ghirardelli",
          "godiva": "Godiva",
          "hersheys": "Hershey's",
          "lindt": "Lindt",
          "milka": "Milka",
          "toblerone": "Toblerone"
        },
        "chart": {
          "aidedLabel": "Aided",
          "subtitle": "Spontaneous mentions vs. recognition from list, per brand.",
          "title": "Awareness funnel",
          "unaidedLabel": "Unaided"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers, premium chocolate category.",
        "summary": {
          "body": "The funnel hides several reversals. Cadbury (38% unaided) beats Hershey's (33%) despite trailing on aided coverage, a sign that top-of-mind position doesn't follow aided rank. Toblerone (82% aided / 16% unaided) and Godiva (71% / 8%) post the widest recognition-without-recall gaps in the set: consumers know the names but they don't surface when the category does. Milka holds the strongest unaided-to-aided ratio in the panel, suggesting a small but loyal mindshare base.",
          "headline": "Lindt is the category top-of-mind brand at 54% unaided and 91% aided, holding a 16-point lead over Cadbury, the next most spontaneously recalled brand."
        },
        "topOfMind": {
          "badge": "Top of mind",
          "subtitle": "Most-mentioned brand when respondents typed without a list shown.",
          "unaidedLabel": "Unaided recall"
        }
      }
    },
    "claimTest": {
      "ctaSubtitle": "Pick the right claim in under 10 minutes.",
      "ctaTitle": "Launch a claim test",
      "methodology": {
        "description": "Each respondent reads every claim, one at a time, and answers the same questions about each. Because every claim is judged on its own, scores reflect how each one actually lands, not how it compares head-to-head.",
        "metrics": {
          "meaning": {
            "description": "What consumers think the claim actually means, in their own words.",
            "title": "Meaning check"
          },
          "persuasion": {
            "description": "A blended score across believability, uniqueness and motivation, so each claim has one number you can compare.",
            "title": "Persuasion score"
          }
        },
        "name": "Sequential monadic"
      },
      "provide": {
        "description": "1 to 5 claims, taglines or product promises. Keep them short: one sentence works best.",
        "examples": {
          "craft": "70 hours of slow conching for a silkier, deeper finish.",
          "origin": "Single-origin Ghanaian cocoa, ethically sourced and cold-pressed.",
          "purpose": "10% of every bar funds reforestation in West Africa."
        },
        "title": "Your claims"
      },
      "sampleReport": {
        "claims": {
          "craft": {
            "name": "70 hours of slow conching"
          },
          "origin": {
            "name": "Single-origin Ghanaian cocoa"
          },
          "purpose": {
            "name": "10% funds reforestation"
          }
        },
        "metrics": {
          "believability": "Believable",
          "motivation": "Motivating",
          "subtitle": "Top-2-box share for each claim on each scale, alongside how respondents read it.",
          "title": "How each claim performed, by metric",
          "uniqueness": "Different"
        },
        "ranking": {
          "subtitle": "Blended score across the three rating questions, on a 0–100 scale.",
          "title": "Persuasion score by claim"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers, 3 claims tested.",
        "summary": {
          "body": "Single-origin Ghanaian cocoa earns the highest blended score, thanks to clear meaning and strong believability. The conching claim is the most distinctive but the hardest to act on: half of respondents aren't sure why it matters. The purpose claim moves people but lands as familiar, since many already expect ethical sourcing from premium brands.",
          "headline": "The origin claim wins on persuasion and motivation; the purpose claim resonates but feels less unique."
        },
        "winner": {
          "badge": "Top claim",
          "compositeLabel": "Persuasion score",
          "subtitle": "Strongest blended score across believability, uniqueness and motivation."
        }
      }
    },
    "example": "Example",
    "getStarted": "Get Started",
    "maxDiff": {
      "ctaSubtitle": "Setup takes less than 2 minutes: paste your list of items and we'll handle the rest.",
      "ctaTitle": "Launch a MaxDiff study",
      "methodology": {
        "description": "Rather than asking respondents to rate items individually, where most things end up rated highly, MaxDiff shows small subsets and asks respondents to pick the best and worst from each. Repeated across many rounds, this produces a precise rank ordering with clear gaps between items.",
        "metrics": {
          "discrimination": {
            "description": "Sharper distinctions than rating scales, even when all items individually appeal",
            "title": "Discrimination"
          },
          "preferenceScore": {
            "description": "Utility-weighted ranking that quantifies how much each item is preferred",
            "title": "Preference Score"
          }
        },
        "name": "Best-Worst Scaling"
      },
      "provide": {
        "description": "4 to 20 distinct features, claims, messages, or attributes you want to prioritize. Short, clear phrasings work best.",
        "title": "List of items"
      },
      "sampleReport": {
        "chart": {
          "subtitle": "Each bar shows how much an item deviates from the average preference. Bars to the right are preferred more than average, bars to the left less than average.",
          "title": "Preference scores"
        },
        "items": {
          "artisans": "Made by small artisans",
          "fairTrade": "Fair-trade certified",
          "lowSugar": "Lower sugar content",
          "premium": "Premium dark experience",
          "richFlavor": "Rich, intense flavor",
          "singleOrigin": "Single-origin cocoa",
          "smoothTexture": "Smooth texture",
          "sustainable": "Sustainable packaging",
          "unique": "Unique flavor pairings",
          "variety": "Wide variety of flavors"
        },
        "subjectLine": "Premium chocolate bar attributes · n = {{count}}",
        "summary": {
          "body": "Sensory drivers dominate: rich flavor, lower sugar content and smooth texture together capture 46% of total preference. Mission-led claims like sustainable sourcing, fair trade and small-batch artisans cluster at or below the 10% average, suggesting they reassure rather than drive choice.",
          "headline": "Rich, intense flavor leads the field at 18.5%, nearly five times the pull of small-batch artisan storytelling at 3.9%."
        }
      }
    },
    "metricLabel": "Metric {{letter}}",
    "monadic": {
      "ctaSubtitle": "Get clean, comparable scores in under 10 minutes.",
      "ctaTitle": "Launch a concept test",
      "methodology": {
        "description": "In monadic testing, each respondent is randomly assigned a concept (or a small sequence of concepts) drawn from your pool and rates each one in isolation on a five-point battery. Because no respondent compares concepts side by side, scores reflect each concept's standalone appeal, the same way it would be encountered on a shelf or on screen.",
        "metrics": {
          "compositeScore": {
            "description": "Average top-2-box across the five metrics. The headline number used to rank concepts.",
            "title": "Composite score"
          },
          "topTwoBox": {
            "description": "The percentage of respondents who rated a metric 4 or 5 on the five-point scale. The standard concept-test KPI.",
            "title": "Top-2-box"
          }
        },
        "name": "Monadic concept test"
      },
      "provide": {
        "description": "Your pool of candidate concepts (1 to 20), each with a name and a short description (image optional).",
        "title": "Concept pool"
      },
      "sampleReport": {
        "concepts": {
          "functional": {
            "description": "A protein-enriched, low-sugar bar built around active lifestyles and clean-label claims.",
            "name": "Cocoa+ Functional"
          },
          "heritage": {
            "description": "A premium single-origin bar with full-bean traceability and sustainability storytelling.",
            "name": "Heritage Cocoa Co."
          },
          "velvet": {
            "description": "An everyday smooth-melt milk chocolate priced for the family weekly shop.",
            "name": "Velvet Daily"
          }
        },
        "heatmap": {
          "subtitle": "Top-2-box scores per concept (cells are shaded by score; deeper cells are stronger).",
          "title": "Per-metric breakdown"
        },
        "metrics": {
          "purchaseIntent": "Purchase intent",
          "recommend": "Likelihood to recommend",
          "relevance": "Relevance to me",
          "uniqueness": "Uniqueness",
          "valueForMoney": "Value for money"
        },
        "ranking": {
          "subtitle": "Composite top-2-box score, averaged across the five metrics.",
          "title": "Concept ranking"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers ({{perCell}} per concept), 3 candidate concepts.",
        "summary": {
          "body": "Heritage owns the premium story: uniqueness (78%) and recommendation intent (71%) anchor the win, but Velvet Daily is the value champion (72%) and the most relevant concept (64%), making it the natural everyday counterweight. Cocoa+ Functional's narrow health angle pulls down purchase intent (45%) despite a respectable distinctiveness score, and is unlikely to carry a launch on its own.",
          "headline": "Heritage Cocoa Co. wins the composite at 62%, edging Velvet Daily by 3.4 points and outperforming Cocoa+ Functional by 13 points."
        },
        "winner": {
          "badge": "Winning concept",
          "compositeLabel": "Composite",
          "subtitle": "Highest composite top-2-box score across the five metrics."
        }
      }
    },
    "notFound": "Use case not found",
    "nps": {
      "ctaSubtitle": "Two questions, one number, wired up in under a minute.",
      "ctaTitle": "Launch an NPS study",
      "methodology": {
        "description": "Net Promoter Score is the industry-standard loyalty metric. Respondents rate likelihood to recommend on a 0–10 scale, then briefly justify the score. Scores are bucketed into Detractors (0–6), Passives (7–8) and Promoters (9–10), and NPS = %Promoters − %Detractors. The verbatim follow-up turns a flat number into actionable themes.",
        "metrics": {
          "breakdown": {
            "description": "Share of Detractors (0–6), Passives (7–8) and Promoters (9–10): the loyalty profile behind the score.",
            "title": "Loyalty mix"
          },
          "score": {
            "description": "%Promoters minus %Detractors, on a −100 to +100 scale. The single number used to track loyalty over time.",
            "title": "NPS score"
          }
        },
        "name": "Net Promoter Score"
      },
      "provide": {
        "description": "A short description of the product, service or brand experience being evaluated.",
        "example": "Premium dark chocolate bar (70% cocoa, 100g): flagship product, six months after a recent recipe change.",
        "title": "What you're measuring"
      },
      "sampleReport": {
        "chart": {
          "subtitle": "Detractors 0–6 · Passives 7–8 · Promoters 9–10. Bars show the share of respondents at each score.",
          "title": "Score distribution"
        },
        "score": {
          "badge": "Headline score",
          "classification": "Good",
          "subtitle": "Above zero and into solid territory: promoters comfortably outweigh detractors, with room to climb."
        },
        "segments": {
          "count": "{{count}} respondents",
          "detractors": {
            "band": "Scores 0–6"
          },
          "passives": {
            "band": "Scores 7–8"
          },
          "promoters": {
            "band": "Scores 9–10"
          }
        },
        "subjectLine": "Premium dark chocolate bar · n = {{count}} consumers",
        "summary": {
          "body": "The biggest single group sits in the passive band: 33% of respondents gave a 7 or 8: they're satisfied but not enthused. Converting even half of them into promoters would push NPS past +50, into top-quartile territory. The detractor base is shallow (18%) and concentrated at scores of 6 rather than the 0–3 floor, suggesting fixable friction rather than entrenched dissatisfaction.",
          "headline": "An NPS of +31 puts the bar in solid loyalty territory, with promoters (49%) clearly outweighing detractors (18%)."
        }
      }
    },
    "packaging": {
      "ctaSubtitle": "Pick the pack that wins on shelf in under 10 minutes.",
      "ctaTitle": "Launch a packaging test",
      "methodology": {
        "description": "Each respondent sees every pack design in your set, one at a time, and answers the same questions about each. Because every pack is judged on its own, scores reflect how each design actually lands, without the bias of side-by-side comparison.",
        "metrics": {
          "clarity": {
            "description": "Whether consumers correctly identify what the product is, just by looking at the pack.",
            "title": "Clarity check"
          },
          "shelfAppeal": {
            "description": "A blended score across appeal and shelf intent, so each pack has one number you can compare.",
            "title": "Shelf appeal"
          }
        },
        "name": "Sequential monadic"
      },
      "provide": {
        "description": "1 to 5 pack designs as images. A short working title for each makes the report easier to read.",
        "examples": {
          "heritage": {
            "description": "Hand-drawn cocoa pod motif on a kraft-look base, brand crest top-center.",
            "name": "Heritage illustrated"
          },
          "minimalist": {
            "description": "Clean serif type on a satin matte sleeve with a foil-stamped percentage.",
            "name": "Minimalist gold foil"
          },
          "vibrant": {
            "description": "Bold color block, sans-serif logo, flavor name in oversized type.",
            "name": "Vibrant modern"
          }
        },
        "title": "Your packs"
      },
      "sampleReport": {
        "metrics": {
          "appeal": "Appeal",
          "brandFit": "Brand fit",
          "shelfIntent": "Shelf pickup",
          "subtitle": "Top-2-box share for each pack on each scale, alongside how respondents read it.",
          "title": "How each pack performed, by metric"
        },
        "packs": {
          "heritage": {
            "name": "Heritage illustrated"
          },
          "minimalist": {
            "name": "Minimalist gold foil"
          },
          "vibrant": {
            "name": "Vibrant modern"
          }
        },
        "ranking": {
          "subtitle": "Blended score across the three rating questions, on a 0–100 scale.",
          "title": "Shelf appeal by pack"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers, 3 packs tested.",
        "summary": {
          "body": "Minimalist gold foil earns the highest blended score thanks to strong shelf intent and high brand fit. Heritage illustrated reads as the most premium and most distinctive, but its drawn imagery confuses a third of respondents about what the product actually is. Vibrant modern is recognized fastest but feels least premium of the three.",
          "headline": "Minimalist gold foil wins on appeal and pickup intent; Heritage illustrated communicates the strongest premium signal."
        },
        "winner": {
          "badge": "Top pack",
          "compositeLabel": "Shelf appeal",
          "subtitle": "Strongest blended score on appeal and pickup intent."
        }
      }
    },
    "pastResults": "Past results",
    "preferenceTest": {
      "ctaSubtitle": "Pick a winner in under 10 minutes.",
      "ctaTitle": "Launch a preference test",
      "methodology": {
        "description": "Every respondent sees all of your options on the same screen and picks the one they prefer, then explains why in their own words. Because it's a head-to-head choice, you get a clear winner plus the reasons behind the verdict.",
        "metrics": {
          "reasons": {
            "description": "Top themes from the open-ended explanations, grouped by which option won them over.",
            "title": "Reasons to win"
          },
          "winRate": {
            "description": "Share of respondents who picked each option as their favorite.",
            "title": "Win share"
          }
        },
        "name": "Forced-choice comparison"
      },
      "provide": {
        "description": "2 to 5 options to compare. They can be images (ads, packs) or short text (claims, taglines).",
        "examples": {
          "optionA": {
            "description": "Cinematic film tracing a single cocoa bean from farm to bar.",
            "name": "Option A: Heritage hero"
          },
          "optionB": {
            "description": "Friends sharing the bar at a rooftop dinner party.",
            "name": "Option B: Lifestyle moment"
          },
          "optionC": {
            "description": "Tight product shot focused on the gold foil and cocoa percentage.",
            "name": "Option C: Functional close-up"
          }
        },
        "title": "Your options"
      },
      "sampleReport": {
        "options": {
          "optionA": {
            "name": "Heritage hero",
            "themes": "Story arc · craft · authenticity"
          },
          "optionB": {
            "name": "Lifestyle moment",
            "themes": "Fun · shareable · feels generic"
          },
          "optionC": {
            "name": "Functional close-up",
            "themes": "Clear product · forgettable"
          }
        },
        "reasons": {
          "subtitle": "Top themes from the open-ended explanations, sorted by frequency.",
          "title": "Why they picked it"
        },
        "share": {
          "subtitle": "Each bar shows how many of the {{count}} respondents picked that option as their favorite.",
          "title": "Share of votes"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers, 3 ads compared.",
        "summary": {
          "body": "Heritage hero wins on emotional pull: respondents repeatedly mention the farm-to-bar journey and feeling drawn in. Lifestyle moment lands as fun and shareable but feels generic to two-thirds of respondents. The functional close-up is the clearest message but the least memorable: nobody mentions it without prompting.",
          "headline": "Heritage hero takes 52% of votes, twice as many as the runner-up. The story arc is what swings it."
        },
        "votesLabel": "{{count}} votes",
        "winner": {
          "badge": "Top option",
          "compositeLabel": "Win share"
        }
      }
    },
    "priceElasticity": {
      "ctaSubtitle": "Setup takes less than 2 minutes with our automated template.",
      "ctaTitle": "Launch a pricing study",
      "methodology": {
        "description": "Rather than asking \"how much would you pay?\", this approach uses four specific questions to identify psychological price barriers. By mapping these perceptions, we visualize the equilibrium between price and perceived quality.",
        "metrics": {
          "opp": {
            "description": "The sweet spot where consumer resistance is minimized",
            "title": "Optimal Price Point (OPP)"
          },
          "range": {
            "description": "Boundaries between \"Cheap\" and \"Expensive\" thresholds",
            "title": "Range of Acceptable Prices"
          }
        },
        "name": "The Van Westendorp Methodology"
      },
      "provide": {
        "description": "A clear description of your product or service, or a photo, so respondents have enough context to price it.",
        "example": "Premium organic dark chocolate bar (70% cocoa, 100g), single-origin from Ecuador, ethically sourced and packaged in recyclable paper.",
        "title": "Description or photo"
      },
      "questions": {
        "bargain": {
          "title": "Bargain"
        },
        "expensive": {
          "title": "Expensive"
        },
        "tooCheap": {
          "title": "Too Cheap"
        },
        "tooExpensive": {
          "title": "Too Expensive"
        }
      }
    },
    "sampleReport": {
      "badge": "Sample report",
      "disclaimer": "All data shown is illustrative.",
      "histogram": {
        "subtitle": "Distribution of prices given by respondents for each threshold question.",
        "title": "Price distribution"
      },
      "keyInsights": "Key insights",
      "subjectLine": "Premium organic dark chocolate bar · n = {{count}}",
      "summary": {
        "body": "At the Optimal Price Point ({{opp}}), an equal share of consumers find the product too cheap as too expensive, minimizing resistance on both sides. Pricing below {{pmc}} risks signaling poor quality, while pricing above {{pme}} pushes most consumers out of the consideration set. The Indifference Price Point ({{ipp}}) marks where as many consumers consider the product a bargain as find it expensive, a strong anchor for everyday positioning.",
        "headline": "Optimal price sits at {{opp}}, with an acceptable range between {{pmc}} and {{pme}}."
      },
      "vw": {
        "ippLabel": "Indifference · {{price}}",
        "ippShort": "IPP",
        "oppLabel": "Optimal · {{price}}",
        "oppShort": "OPP",
        "pmcLabel": "Floor · {{price}}",
        "pmcShort": "PMC",
        "pmeLabel": "Ceiling · {{price}}",
        "pmeShort": "PME",
        "subtitle": "Cumulative share of respondents at each price level. Intersections reveal the optimal price and acceptable range.",
        "title": "Van Westendorp price-sensitivity curves",
        "xLabel": "Price"
      }
    },
    "turf": {
      "ctaSubtitle": "Get an answer in under 10 minutes.",
      "ctaTitle": "Launch a TURF study",
      "methodology": {
        "description": "TURF (Total Unduplicated Reach and Frequency) tests every possible combination from your candidate list to find the lineup that reaches the most unique respondents while keeping overlap low.",
        "metrics": {
          "frequency": {
            "description": "Average number of items each respondent would consider from a given portfolio.",
            "title": "Frequency"
          },
          "reach": {
            "description": "Percentage of respondents who would consider at least one item in a given portfolio.",
            "title": "Unduplicated reach"
          }
        },
        "name": "Total Unduplicated Reach and Frequency"
      },
      "provide": {
        "description": "5 to 20 distinct products, flavors, features, or messages you might offer. Short, clear phrasings work best.",
        "title": "List of items"
      },
      "sampleReport": {
        "chart": {
          "elbowLabel": "Optimal portfolio size",
          "reachLabel": "Unduplicated reach",
          "subtitle": "Each point shows how much of the audience is covered by the best portfolio of that size. The marked point is where adding another item stops moving the needle.",
          "title": "Reach by portfolio size",
          "xLabel": "Portfolio size",
          "yLabel": "Reach"
        },
        "items": {
          "almond": "Almond chocolate",
          "coconut": "Coconut chocolate",
          "dark": "Dark chocolate (70% cocoa)",
          "hazelnut": "Hazelnut chocolate",
          "milk": "Milk chocolate",
          "mint": "Mint chocolate",
          "orange": "Orange-infused chocolate",
          "raspberry": "Raspberry chocolate",
          "saltedCaramel": "Salted caramel chocolate",
          "white": "White chocolate"
        },
        "portfolio": {
          "reachLabel": "Unduplicated reach",
          "subtitle": "Optimal lineup of {{size}} items",
          "title": "Recommended portfolio"
        },
        "rawCounts": {
          "subtitle": "How many respondents would consider each flavor on its own. The optimization above uses these signals to find the smallest portfolio that covers the most unique buyers.",
          "title": "Selection per flavor"
        },
        "subjectLine": "Synthetic study, n = {{count}} consumers, 10 candidate flavors.",
        "summary": {
          "body": "Milk chocolate is the strongest individual draw at 37%, but the optimal lineup only works because mint reaches buyers the cocoa-forward flavors miss. The four laggards (white, orange, raspberry and coconut) all under-index on their own and add little once the top five are seated.",
          "headline": "Milk, dark, salted caramel, hazelnut and mint together reach 84% of buyers; adding a sixth flavor lifts coverage by only 1.5 points."
        }
      }
    },
    "viewSampleReport": "View sample report",
    "whatYoullProvide": "What you'll need to provide"
  }
}
